<div class="cg-dialog">
  <h2 class="cg-dialog__header">
    Site Help
    <button
      cignaButton="link inline no-underline"
      class="cg-dialog__close_new"
      (click)="close()"
    >
      Close
      <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <h4 class="cg-margin-bottom-sm">Before you register</h4>

    <cigna-collapsible-item headerText="Tell me about Provider.Evernorth.com">
      <p>
        Provider.Evernorth.com will provide access to patient, claim, remittance
        information, resources, and more for behavioral providers.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item
      headerText="Who can register for the Evernorth provider website (Provider.Evernorth.com)?"
    >
      <p>
        Behavioral practitioners, clinics and facilities, as well as any
        representatives they choose, can register. Providers who offer both
        medical and behavioral services can register for Provider.Evernorth.com
        or CignaforHCP.com. Registration will grant access to both websites.
      </p>
      <p>
        A Taxpayer Identification Number (TIN) is required to access tools such
        as eligibility and benefits, claims and remittance information. Up to 50
        TINs can be registered to a single user ID. If your organization does
        not have a TIN, the user can click on the “I don’t have a TIN” link and
        continue with registration. Users without a TIN will have access to
        resources only.
      </p>
      <p>
        Non-contracted providers can register, as long they have submitted a
        claim to Cigna or Evernorth.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item
      headerText="How do I register for the Provider.Evernorth.com website?"
    >
      <p>A new user may obtain access to the website in one of two ways:</p>
      <ol>
        <li>
          Through the website access manager, who will add the user and assign
          the appropriate level of access. The website access manager will send
          a temporary ID and password which will allow the new user to login and
          complete the registration process. The user will have immediate access
          to the assigned functionalities.
        </li>
        <li>
          On their own through Provider.Evernorth.com. This requires vetting and
          confirmation by the website access manager and may take longer to
          complete than the option above.
        </li>
      </ol>
      <p>
        Each TIN with registered users will have a designated person(s) known as
        the website access manager. The website access manager for the TIN will
        be notified when a user registers and assign the appropriate level of
        access. Until the website access manager has granted the user access,
        the user will only have access to resources and policies.
      </p>
      <p>
        If you are the first person in your practice or facility to register,
        you can obtain a user ID and create a password by clicking “Register
        Now” on the Log In page. Your office will be called by an Internet
        Customer Service Associate to help establish a website access manager.
        If the website access manager has not been established and it has been
        more than 5 business days since you registered, please call Internet
        Customer Service at 888.736.7499.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="I’m not contracted with Evernorth. Can I still register?"
    >
      <p>
        Non-contracted providers can register, as long they have submitted a
        claim. All functionality will be available except for the ability to
        update demographic information.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="Do I need a separate user ID and password to access medical and behavioral information?"
    >
      <p>
        You may have the same user ID and password to access medical and
        behavioral information.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item headerText="Can I register for more than one TIN?">
      <p>
        Individuals can register for multiple TINs (up to 50 TINs can be added
        for one user ID). If you have already completed registration, you can
        also request access to a new TIN(s) under Settings & Preferences > >
        Online Access > Request TIN access. This will direct your request to a
        website access manager for that TIN.
      </p>
      <p>
        If a website access manager has not been set up yet, you will be
        prompted to provide details about who the website access manager should
        be, if known.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item headerText="What is a website access manager?">
      <p>
        Each group registered on the Evernorth provider website
        (Provider.Evernorth.com) is required to assign at least one, and up to
        15, user(s) as the website access manager(s). The “Delegate access and
        view delegation history report” is the entitlement which grants a user
        the role of website access manager. The website access manager at each
        practice controls the appropriate level of access to the website for all
        users tied to the TIN(s).
      </p>
      <p>Website access managers have three key responsibilities:</p>
      <ol>
        <li>Register or approve new users for the TIN(s)</li>
        <li>
          Assign or modify the website functions to which users should have
          access
        </li>
        <li>Remove access for users who no longer need it.</li>
      </ol>
      <p>
        Visit our
        <a
          target="resourcesWindow"
          [href]="
            '/resourceLibrary/behavioralResources/websiteAccessManagers'
              | resourceLink : { secure: false, targetApp: 'both' }
              | async
          "
          >website access manager resource page</a
        >.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item
      headerText="I represent a billing company for multiple providers. How do I register?"
    >
      <p>
        Contact the provider’s website access manager you represent and ask them
        to assign access to you. If you have more than one temporary user ID
        (each giving you access to different TINs), you can log in with a single
        user ID and password and the temporary user ID and password under
        Settings & Preferences > Online Access > Add access rights from
        temporary ID/Password.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item
      headerText="I received a temporary ID and password. What do I do? "
    >
      <p>
        A temporary ID and password is assigned to you when a website access
        manager has granted you access to Provider.Evernorth.com for one or more
        TINs.
      </p>
      <ul>
        <li>
          If you already have a user ID and password: You can use the temporary
          ID and password to add the new access to your existing user ID. Login
          with your existing user ID and navigate to Settings & Preferences >
          Online Access > Add access rights from temporary ID/Password.
        </li>
        <li>
          If you do not have access yet: Click on the “I have a temporary ID”
          link on the login page and complete your registration.
        </li>
      </ul>
    </cigna-collapsible-item>

    <h4 class="cg-margin-bottom-sm cg-margin-top-xl">After you register</h4>

    <cigna-collapsible-item
      headerText="I am newly registered for the website. Why can’t I access the information I need (for example, patient and claim details)?"
    >
      <p>
        The website access manager at your organization has given you access to
        certain functionality on the Evernorth website for providers. Please
        contact your website access manager to request any additional access you
        need.
      </p>

      <p>
        If a website access manager has not yet been established for the
        Taxpayer Identification Number (TIN) under which you registered,
        Evernorth will contact your office within approximately 10 business days
        to help establish one.
      </p>

      <p>
        If you do not know who your website access manager is, please call
        888.736.7499.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item
      headerText="Who do I contact if I need access to additional information on the website?"
    >
      <p>
        You should contact the website access manager at your organization to
        request the additional access you need.
      </p>

      <p>
        If a website access manager has not yet been established for the
        Taxpayer Identification Number (TIN) under which you registered,
        Evernorth will contact your office within approximately 10 business days
        to help establish one.
      </p>

      <p>
        If you do not know who your website access manager is, please call
        888.736.7499.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item
      headerText="What if I don’t know who my website access manager is?"
    >
      <p>
        Log in to Provider.Evernorth.com. Click the drop-down menu under your
        name and select Settings and Preferences > Online access > View TIN
        access. Select your TIN; the name of the website access manager will be
        shown at the bottom of the screen.
      </p>

      <p>
        Please call our internet customer service advocates at 888.736.7499 for
        assistance.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item headerText="When is the website available?">
      <p>Hours of Availability:</p>
      <p>
        The Evernorth provider website and EDI real-time transactions are
        generally available 24 hours a day, 365 days a year.
      </p>

      <p>
        To allow for maintenance, the website and EDI real-time transactions may
        be unavailable on Sundays from 12:01 a.m. until 10:00 a.m. ET.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="How many TINs can a user access?">
      <p>A single user ID can access up to 50 TINs.</p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="How many users can be aligned to a TIN?"
    >
      <p>
        There is no limit to the number of users that can be aligned to a TIN,
        however, for security purposes, the website access manager should keep
        the list of users current. There can be up to 15 website access managers
        per TIN.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="Can I add an additional TIN to my existing user ID?"
    >
      <p>
        Yes. After logging in, click on your name in the top right corner and
        access Settings and Preferences > Online Access > Add TIN. The website
        access manager(s) will be notified and can grant you access. A list of
        website access managers and their phone numbers will be displayed for
        your reference.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item
      headerText="How do I remove a website access manager?"
    >
      <p>
        Any website access manager tied to the TIN can modify or remove access
        of another website access manager. Navigate to My Practice > Manage User
        Access > click on ‘All users’ and locate and select the applicable user
        ID(s), click the ‘View and edit selected User(s)’ button and finish
        adding or removing the access you need. The “Delegate access and view
        delegation history report” entitlement is what grants a user the role of
        website access manager.
        <a
          target="resourcesWindow"
          [href]="
            '/resourceLibrary/behavioralResources/websiteAccessManagers'
              | resourceLink : { secure: false, targetApp: 'evernorth' }
              | async
          "
          >Website access manager resource page</a
        >
      </p>
    </cigna-collapsible-item>

    <h4 class="cg-margin-top-xl cg-margin-bottom-sm">
      About logging in, your password, security and privacy
    </h4>
    <cigna-collapsible-item
      headerText="Why am I being asked to provide a security code when logging in? "
    >
      <p>
        Two step authentication offers an extra layer of security to help
        prevent use of the website by unauthorized users, and further protects
        the privacy of your organization and your patients.
        <a
          target="resourcesWindow"
          [href]="
            '/resourceLibrary/behavioralResources/doingBusinessWithUs/dbwuTwoStepAuthFaq'
              | resourceLink : { secure: false, targetApp: 'evernorth' }
              | async
          "
          >Two-step authentication overview and FAQs</a
        >
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="When does my password expire?">
      <p>
        For your security, passwords expire every 120 days. You can change your
        password at any time by accessing Settings and Preferences > Security &
        Login > Site Password.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="If my password expires, how do I reset it?"
    >
      <p>
        You can reset your password online by correctly answering the security
        questions you set up during registration. Click the “Forgot your
        password” link directly under the user name and password fields on the
        log in page.
      </p>
      <p>
        If you are unable to reset your password online and you are a website
        access manager, call Internet Customer Service at 800.981.9114 to have
        your password reset. You may also contact your website access manager
        and request that your password be reset.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="What steps should I take to ensure the security of my information?"
    >
      <p>
        You share responsibility for maintaining the security of your personal
        and provider information when using online services. Never share your
        password with anyone. When you finish with the website, always use the
        log out button to leave the service and close the browser.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="What if someone learns my password?"
      ><p>
        If you suspect that someone knows your password, you can change it by
        clicking Settings & Preferences > Security & Login > Change Password.
        Each user is required to have their own individual password.
      </p>
      <p>
        If you have trouble changing your password, you can request help from
        your website access manager.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item
      headerText="How can I change my password on the Evernorth provider website?"
    >
      <p>
        Log-in to Provider.Evernorth.com and click on Settings & Preferences >
        Security and Login, then Change Password. Each user is required to have
        their own individual password.
      </p>
      <p>
        If you use a third-party website, such as OneHealthPort or NaviNet, to
        access Provider.Evernorth.com, you will not have access to Settings &
        Preferences on the Evernorth website. You will need to change your
        password on the third-party website.
      </p>
      <p>
        If you have trouble changing your password, you can request help from
        your website access manager.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="What is Evernorth’s privacy policy?">
      <p>
        To review Evernorth’s privacy policy, click on the Privacy Information
        link at the bottom of any page.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="How can I tell if my online session with Evernorth is encrypted?"
    >
      <p>
        Microsoft Edge, Google Chrome, Mozilla Firefox, and Apple Safari all use
        a padlock icon by the browser field to represent an encrypted session.
        An open lock indicates that your session is not encrypted. Although an
        open lock might appear when the page loads between two encrypted pages,
        the session is still encrypted if the closed lock is present when the
        page has finished loading.
      </p>
    </cigna-collapsible-item>

    <h4 class="cg-margin-bottom-sm">About your browser</h4>
    <cigna-collapsible-item headerText="What kind of browser do I need?">
      <p>
        The Provider.Evernorth.com website works well with a variety of
        browsers, including Microsoft Edge, Mozilla FireFox, Google Chrome and
        Apple Safari. Using the most up-to-date browser version will minimize
        the likelihood that your session with Evernorth could be interrupted. If
        you are having trouble registering or using the site, and you have
        checked your browser, please contact your internet service provider or
        your employer's technical support group.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="What is a 'cookie?'">
      <p>
        A cookie is a small file on your computer that saves internet settings.
        Cookies can keep you signed in, remember your site preferences, and give
        you locally relevant content. Because cookies are saved to your
        computer, the settings they save will only apply to the specific
        computer and browser that you used to set those preferences. Therefore,
        cookies are especially helpful if you typically use the same computer
        and browser.
      </p>
      <p>
        Cookies should be enabled in your internet browser in order for you to
        experience the full convenience of the provider website.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="What does 'clear my cache' mean?">
      <p>
        When you use web browsers, your history, temporary internet files, and
        cookies are stored on your computer. While these stored files can help
        you access information faster, they also take up disk space. If your
        disk is full, certain web-based applications may not open properly or
        run well. It is a best practice to remove temporary files on a regular
        basis. This is often referred to as "clearing your cache."
      </p>
      <p>
        Generally, you can clear your cache by using your browser's settings and
        looking for the browser's history, temporary files, and "cookies" – and
        then delete them. Each browser will have help information specific to
        how to do this for that browser. Please look for your browser's "Help"
        section.
      </p>
    </cigna-collapsible-item>
    <h4 class="cg-margin-bottom-sm">
      If you still need assistance with this website, please visit Resources >
      <a
        target="resourcesWindow"
        [href]="
          '/resourceLibrary/eCourses/eCourseBehavioralListing'
            | resourceLink : { secure: false, targetApp: 'evernorth' }
            | async
        "
        >Behavioral Training and Education</a
      >. Or you can call Internet Customer Service at 1.888.736.7499
    </h4>
  </mat-dialog-content>
</div>
